import React, { useEffect } from 'react';
import { string } from 'prop-types';
import {
  params,
  shape,
  string as stringType,
  arrayOf,
  number as numberType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Section } from './Section';
import { Dropdown } from './Dropdown';
import { Outro } from './Outro';
import styles from './article-section.module.scss';

const ArticleSections = ({ articleGUID }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('author-title.ready'); }, []);

  const { data, loading, error } = useDataModel('article', {
    variables: { articleGUID }
  });

  if (!data || loading || error) return null;

  const sections = data?.article?.sections || [];
  const articleType = data?.article?.articleType;

  if (!sections.length) return null;

  const renderedSections = sections
    .map(({
      name,
      imageName,
      imageURL,
      instruction,
      stepNumber,
      fields
    }, index) => (
      <Section
        key={index}
        imageName={imageName}
        imageURL={imageURL}
        instruction={instruction}
        name={name}
        stepNumber={stepNumber}
        articleType={articleType}
        index={index}
        fields={fields}
      />
    ));

  return (
    <div data-testid="articleSections" className={styles['article-sections']}>
      <Dropdown
        sections={sections}
        articleType={articleType}
      />
      {renderedSections}
      <div>
        <Outro
          articleGUID={articleGUID}
        />
      </div>
    </div>

  );
};

ArticleSections.displayName = 'ArticleSections';

ArticleSections.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    sections: arrayOf(shape({
      comparisonDropdownValues: shape({
        display: stringType(),
        value: stringType(),
      }),
      fields: arrayOf(shape({
        description: stringType(),
        product: arrayOf(shape({
          description: stringType(),
          id: stringType(),
          image: stringType(),
          quantity: numberType(),
          title: stringType(),
          url: stringType(),
        })),
      })),
      name: stringType(),
      imageName: stringType(),
      imageURL: stringType(),
      instruction: stringType(),
      stepNumber: numberType()
    })),
    articleType: stringType(),
    outro: stringType()
  }),
};

ArticleSections.propTypes = {
  articleGUID: string.isRequired
};

export { ArticleSections };
